import { ViewModel,View, ObservableArray } from "binder"
import  { WarehouseKeepingPartDetailView } from "./warehouseKeepingPartDetail-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { WarehouseKeepingDetailViewModel } from "../warehouseKeepingDetail/warehouseKeepingDetail-viewModel";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class WarehouseKeepingPartDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: WarehouseKeepingDetailViewModel, warehouseKeepingId: string, keepingPartId: string) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.warehouseKeepingId = warehouseKeepingId;
        this.keepingPartId = keepingPartId;
        this.load();

        this.keepingPartProducts = ObservableArray.create<KeepingPartProduct>();
    }
    closePopup(resultCode?: string) {
        this._typedParent.closePopup();
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseKeepingPartDetailView();
    }
    public getTypeId(): string {
        return "VM-73CF5D97-DF4B-4F89-817F-544AFA4E4DCA"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set keepingPartId(v: string) { this._keepingPartId = v; } public get keepingPartId(): string { return this._keepingPartId;} private _keepingPartId: string;
    public set createTime(v: moment.Moment) { this._createTime = v; } public get createTime(): moment.Moment { return this._createTime;} private _createTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set totalCountedAmount(v: number) { this._totalCountedAmount = v; } public get totalCountedAmount(): number { return this._totalCountedAmount;} private _totalCountedAmount: number;
    public set totalAmount(v: number) { this._totalAmount = v; } public get totalAmount(): number { return this._totalAmount;} private _totalAmount: number;
    public set hasCountAccess(v: boolean) { this._hasCountAccess = v; } public get hasCountAccess(): boolean { return this._hasCountAccess;} private _hasCountAccess: boolean;
    public set hasConfirmAccess(v: boolean) { this._hasConfirmAccess = v; } public get hasConfirmAccess(): boolean { return this._hasConfirmAccess;} private _hasConfirmAccess: boolean;
    public set keepingPartProducts(v: ObservableArray<KeepingPartProduct>) { this._keepingPartProducts = v; } public get keepingPartProducts(): ObservableArray<KeepingPartProduct> { return this._keepingPartProducts;} private _keepingPartProducts: ObservableArray<KeepingPartProduct>;
    
    private _typedParent : WarehouseKeepingDetailViewModel;

    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/LoadKeepingPartDetails',{
                KeepingId:this.warehouseKeepingId,
                PartId:this.keepingPartId,
            });
            this.createTime = moment.utc(result.StartTime);
            this.endTime = result.EndTime==null ? null : moment.utc(result.EndTime);
            this.warehouseId = result.WarehouseId;
            this.warehouseName = result.WarehouseName;
            this.hasConfirmAccess = result.IsWarehouseKeepingConfirmer;
            this.hasCountAccess = result.IsWarehouseKeepingCounter && !this.hasConfirmAccess;
            this.keepingPartProducts.update(...result.Products.map((q,i)=>{
                let r = new KeepingPartProduct(this);
                r.index = i+1;
                r.countedProductId = q.CountedProductId;
                r.reason = q.Reason;
                r.productName = q.Name;
                r.productBrand = q.Brand;
                r.productCarModel = q.ProductCarModel;
                r.productCode = q.Code;
                r.productIndex = q.ProductIndex;
                r.productId = q.ProductId;
                r.balance = q.Balance;
                r.countedAmount = q.CountedAmount;
                r.locations = q.Locations;
                r.showFeePrice = this.hasConfirmAccess && r.diffrence > 0;
                return r;
            }));
            this.totalAmount = this.keepingPartProducts.reduce((i,q) => q.balance + i, 0);
            this.totalCountedAmount = this.keepingPartProducts.reduce((i,q) => q.countedAmount + i, 0);
            if (this.hasConfirmAccess) {
                this.updateReceiptFeePrice();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async updateReceiptFeePrice(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetLastWarehouseReceiptBillMeanPrice',{
                WarehouseId: this.warehouseId,
                MeasuredProductIds: this.keepingPartProducts.filter(q => q.diffrence > 0).map(q => { return q.productId})
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            result.MeanPrices.map(p=>{
                let product = this.keepingPartProducts.filter(q => q.productId == p.MeasuredProductId)[0];
                product.feePrice = p.MeanPrice;
            });
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    private validate():string[]{
        let faults : string[] = [];
        if(this.keepingPartProducts.length==0){
            faults.push('هیچ کالایی وجود ندارد.');
        }else{
            let amountsWithInvalidAmounts = this.keepingPartProducts.filter(x=>x.diffrence != 0 && stringIsNullOrEmpty(x.reason));
            if(amountsWithInvalidAmounts.length>0){
                faults.push(`${amountsWithInvalidAmounts.length==1 ? 'سطر' : 'سطرهای'} ${amountsWithInvalidAmounts.map(x=>x.index).join(' و ')} علتش مشخص نشده.`);
            }
        }
        return faults;
    }

    async updatePart() {
        let validationResult = this.validate();
        if(validationResult.length>0){
            await this.messageBoxConfirmWarning(validationResult.join("\r\n"),'خطا');
            return;
        }
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('شمارش ثبت شود؟','ثبت شمارش');
            if(confirmation=='no'){
                return;
            }
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/UpdateCountingResults',{
                KeepingId: this.warehouseKeepingId,
                PartId: this.keepingPartId,
                Amounts: this.keepingPartProducts.map(q => { return {
                    ProductId: q.countedProductId,
                    CountedAmount: q.countedAmount,
                    Reason: q.reason,
                }})
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('شمارش کالاها با موفقیت ثبت شد.','عملیات موفق');
            this.closePopup('done');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async finalConfirm() {
        let validationResult = this.validate();
        if(validationResult.length>0){
            await this.messageBoxConfirmWarning(validationResult.join("\r\n"),'خطا');
            return;
        }
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('شمارش تایید شود؟','تایید شمارش');
            if(confirmation=='no'){
                return;
            }
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/ConfirmCountingResults',{
                KeepingId: this.warehouseKeepingId,
                PartId: this.keepingPartId,
                FeePrices: this.keepingPartProducts.map(q => { return {
                    MeasuredProductId: q.productId,
                    FeePrice: q.feePrice
                }})
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('شمارش کالاها تایید شد.','عملیات موفق');
            this.closePopup('done');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
}

export class KeepingPartProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingPartDetailViewModel) {
        super(parent);
        this._typedParent = parent;   
    }
    private _typedParent:WarehouseKeepingPartDetailViewModel;

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set countedProductId(v: string) { this._countedProductId = v; } public get countedProductId(): string { return this._countedProductId;} private _countedProductId: string;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set countedAmount(v: number) { 
        this._countedAmount = getAsNumber(v,true); 
        this.diffrence = this._countedAmount - this.balance;
        this.hasDiffrence = this.diffrence != 0;
        if(this.diffrence < 0) 
            this.status = 'کمبود';
        else if(this.diffrence > 0) 
            this.status = 'پیدا شده';
        else            
            this.status = 'صحیح';
        
    } public get countedAmount(): number { return this._countedAmount;} private _countedAmount: number;
    public set diffrence(v: number) { this._diffrence = v; } public get diffrence(): number { return this._diffrence;} private _diffrence: number;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status;} private _status: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set locations(v: string) { this._locations = v; } public get locations(): string { return this._locations;} private _locations: string;
    public set hasDiffrence(v: boolean) { this._hasDiffrence = v; } public get hasDiffrence(): boolean { return this._hasDiffrence;} private _hasDiffrence: boolean;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice;} private _feePrice: number;
    public set showFeePrice(v: boolean) { this._showFeePrice = v; } public get showFeePrice(): boolean { return this._showFeePrice;} private _showFeePrice: boolean;
    
}
